import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import XlContainer from 'components/XlContainer'
import StandardLayout from 'components/StandardLayout'
import { RenderOnDesktop, RenderOnMobile } from 'components/DeviceUtils'
import CustomerBanner from 'components/CustomerBanner'
import GreyGradient from 'components/GreyGradient'
import useIsMobile from 'hooks/useIsMobile'
import BuyCarbonCreditsTabSection from 'views/Customers/Sections/BuyCarbonCredits/BuyCarbonCreditsTabSection'
import QuoteCardsCarousel from './QuoteCardsCarousel'

const stackSpacing = {
    xs: 10,
    sm: 15,
    md: 15,
    lg: 15,
    xl: 15,
}

const BuyCarbonCredits = () => {
    const isMobile = useIsMobile()
    return (
        <>
            <XlContainer>
                <Stack
                    spacing={stackSpacing}
                    sx={{
                        pt: {
                            xs: 9,
                            sm: 15,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        },
                    }}
                >
                    <GreyGradient radial>
                        <StandardLayout sx={{ pb: 3 }}>
                            <RenderOnMobile>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `left` }}
                                >
                                    Contributing to carbon projects that they can feel proud of
                                </Typography>
                            </RenderOnMobile>
                            <RenderOnDesktop>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `center` }}
                                >
                                    Contributing to carbon projects
                                </Typography>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `center` }}
                                >
                                    that they can feel proud of
                                </Typography>
                            </RenderOnDesktop>
                        </StandardLayout>
                    </GreyGradient>
                </Stack>
            </XlContainer>
            <XlContainer>
                <Stack
                    spacing={stackSpacing}
                    sx={{
                        pt: {
                            xs: 9,
                            sm: 15,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        },
                    }}
                >
                    <GreyGradient hide={!isMobile}>
                        <StandardLayout sx={{ py: isMobile ? 0 : 10 }}>
                            <BuyCarbonCreditsTabSection />
                        </StandardLayout>
                    </GreyGradient>

                    <StandardLayout sx={{ pt: stackSpacing }}>
                        <QuoteCardsCarousel />
                    </StandardLayout>

                    <StandardLayout sx={{ pt: stackSpacing }}>
                        <CustomerBanner
                            image={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/forto2-desktop.png'}
                                    alt={'bridge'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            mobileImage={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/forto2-mobile.png'}
                                    alt={'bridge'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            customerLogo={'https://assets.lune.co/lune-co/tabs-logos/forto.png'}
                            text="We assessed several providers and found that Lune is truly challenging the status quo"
                        />
                    </StandardLayout>
                </Stack>
            </XlContainer>
        </>
    )
}

export default BuyCarbonCredits
